module.exports = __webpack_public_path__ + "img/C_legacy.107950b8.png";